<template>
	<div class="main">
		<div style="margin-top: 20px;overflow: hidden;">
			<div class="data">
				<div class="data_div" style="background: #32cd84;">
					<div style="padding-top: 15px;">用户数</div>
					<div style="padding-top: 20px;font-size: 25px;">{{count.user_count}}</div>
				</div>
			</div>
			<div class="data">
				<div class="data_div" style="background: #32cd84;">
					<div style="padding-top: 15px;">商品数</div>
					<div style="padding-top: 20px;font-size: 25px;">{{count.goods_count}}</div>
				</div>
			</div>
			<div class="data">
				<div class="data_div" style="background: #32cd84;">
					<div style="padding-top: 15px;">订单数</div>
					<div style="padding-top: 20px;font-size: 25px;">{{count.order_count}}</div>
				</div>
			</div>
		</div>
		<div style="background: white;margin-top: 20px;margin-bottom:20px;text-align: left;overflow: hidden;padding: 30px;">
			<div style="width: 50%;float: left;">
				<el-date-picker
				  v-model="date_time"
				  type="daterange"
				  value-format="yyyy-MM-dd"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期">
				</el-date-picker>
				<el-button type="primary" style="margin-left: 20px;" @click="search">搜索</el-button>
			</div>
			<div style="width: 50%;float: left;line-height: 30px;text-align: right;">
				订单数：<span style="font-size: 20px;color: green;">{{order.count}}</span>；总金额：<span style="font-size: 20px;color: red;">{{order.price}}</span>；
			</div>
		</div>
		<div style="background: white;margin-top: 20px;">
			<!-- <div style="padding-top: 30px;">
				<el-date-picker
				  v-model="date_time"
				  type="daterange"
				  value-format="yyyy-MM-dd"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期">
				</el-date-picker>
				<el-button type="primary" style="margin-left: 20px;" @click="search">搜索</el-button>
			</div> -->
			<div style="width:100%;height:500px;padding: 20px;" ref="chart"></div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'Test',
		data() {
			return {
				date_time:[],
				count:{
					"user_count":0,
					"goods_count":0,
					"order_count":0
				},
				order:{
					"price":0,
					"count":0,
				}
			}
		},
		methods: {
			async search(){
				let res=await this.$get('/index/Census/GetPrice',{"date_time":this.date_time});
				if(res.errCode=="0"){
					this.$error(res,this);
					return;
				}
				this.order=res.result;
				
			},
			async getCode(){
				let res=await this.$get('/index/Census/GetCode',"");
				this.count=res.result;
			},
			async initCharts() {
				let res=await this.$get('/index/Census/GetData',"");
				//获取数据
				let myChart = this.$echarts.init(this.$refs.chart);
				// 绘制图表
				myChart.setOption({
					title: {
						text: '近7日成交额'
					},
					tooltip: {},
					xAxis: {
						data: res.result.label
					},
					yAxis: {},
					series: [{
						name: '成交额',
						type: 'bar',
						data: res.result.value,
						type: 'line'
					}]
				});
			}

		},
		mounted() {
			this.initCharts();
			this.getCode();
		}
	}
</script>

<style scoped="scoped">
	.data {
		float: left;
		width: 33%;
		height: 100px;
		text-align: center;
		color: white;
	}

	.data_div {
		width: 80%;
		background: white;
		height: 100px;
		box-shadow: 2px 2px 2px #c4c3c3;
	}
</style>
